//Importaciones
import React, { useContext } from 'react'
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import GAPBox from '../../../components/Products/sKPI/GAP/V2/GAPBox';
import GapRevisionsBox from '../../../components/Products/sKPI/GAP/V2/GapRevisionsBox';
import GapDataseriesBox from '../../../components/Products/sKPI/GAP/V2/GapDataseriesBox';
import GapDataserieFullBox from '../../../components/Products/sKPI/GAP/V2/GapDataserieFullBox';
import { useGetGapAefFishbones_AND_RevisionDataserieFullList, useGetGAPById, useGetGapRevisionDatareieList, useGetGAPElementsByGAPId, useGetListGapAnalyzeDataseriesIds, useGetGapRevisionsList, useGetCreateGapAnalyzeProcessByElementId } from '../../../hooks/services/sKPI/useOfGAP';
import { __OBJECT_STRUCTURE_GetGAP } from '../../../common/ObjectStructures/sKPI';
import GapActionStadistic from '../../../components/Products/sKPI/GAP/V2/GapActionStadistic';
import GapAppContext from '../../../GapAppContext';
import MainAppContext from '../../../MainAppContext';
import { __OBJECT_STRUCTURE_GetList } from '../../../common/ObjectStructures/Trasnversal';
import AuthVerify from '../../../components/Templates/Site/AuthVerify';
import { useSelector } from 'react-redux';
import Loading from '../../../components/Templates/Site/Loading';
import { useGetUserPropsKpi } from '../../../hooks/services/sPrivilege/useOfPrivilege';
import { __enum_TeachGapPage, enum__BOARD_TEMPLATE_TYPE } from '../../../common/Dictionaries';
import MessageBox from '../../../components/Common/Message/MessageBox';

//Color del KPI
//Rojo: Cuando exiten dataseries values que tiene brecha pero no tienen ninguna brecha manipulada que vaya mas haya del detectado.
//Naranjo/amarillo: Cuando existe al menos una acción en las brechas que ha sido abordada.
//Verde: Cuando todas las brechas estan solucionadas.
//Azul: Cuando estan todas las acciones entre "por comprometer" y "comprometidas".

//Color dataserie value
//Rojo: Existe brecha detectada.
//Amarillo: Ha sido abordada y tiene causas.
//Azul: Tiene acciones entre "por comprometer" y "comprometidas".
//Verde: Todas las acciones solucionadas.

function Gap(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);

    const contextSite = useContext(MainAppContext);

    //Parametros de componente.
    const queryStringElementId = props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ? props.match.params.elementId : null;
    
    const [gapAnalyze, setGapAnalyze] = useState({id: null });
    useGetCreateGapAnalyzeProcessByElementId(queryStringElementId, gapAnalyze, setGapAnalyze)

    const [selectedElementId, setSelectedElementId] = useState(null);
    const [selectedRevision, setSelectedRevision] = useState(null);
    const [selectecDataserieId, setSelectecDataserieId] = useState(0);
    const [higthLigthDataserieList, setHigthLigthDataserieList] = useState(null);
    
    const [fireGetLastActions, setFireGetLastActions] = useState(false);
    
    const [objGAP, setObjGAP] = useState(__OBJECT_STRUCTURE_GetGAP());
    useGetGAPById(gapAnalyze.id !== 0 && gapAnalyze.id !== null ? gapAnalyze.id : null, objGAP.id, setObjGAP, null)

    const [elementList, setElementList] = useState(null);
    useGetGAPElementsByGAPId(objGAP.id, elementList, setElementList, setSelectedElementId)

    const [gapAnalyzeDataseriesIds, setGapAnalyzeDataseriesIds] = useState(null);
    useGetListGapAnalyzeDataseriesIds(objGAP.id, queryStringElementId, null, gapAnalyzeDataseriesIds, setGapAnalyzeDataseriesIds);

    const [gapRevisionsList, setGapRevisionsList] = useState(__OBJECT_STRUCTURE_GetList());
    const [gapRevisionsListFiltred, setGapRevisionsListFiltred] = useState(__OBJECT_STRUCTURE_GetList());
    useGetGapRevisionsList(gapAnalyze.id !== 0 && gapAnalyze.id !== null ? gapAnalyze.id : null, gapRevisionsList.data, setGapRevisionsList, setGapRevisionsListFiltred, setSelectedRevision, true) 

    const [gapRevisionDataserieList, setGapRevisionDataserieList] = useState(null);
    useGetGapRevisionDatareieList(gapAnalyze.id !== 0 && gapAnalyze.id !== null ? gapAnalyze.id : null, queryStringElementId, gapRevisionDataserieList, setGapRevisionDataserieList) 

    const [dataserieFullData, setDataserieFullData] = useState({
        revisionDataserieFullList: null,
        gapFishboneList: null,
        fireUpdateLastAction: true
    });

    useGetGapAefFishbones_AND_RevisionDataserieFullList(gapAnalyze.id !== 0 && gapAnalyze.id !== null ? gapAnalyze.id : null, queryStringElementId, selectecDataserieId, contextSite.kpiModule.boardCalendarFilterConfig.value, setDataserieFullData, dataserieFullData)

    const [userPropsKpi, setSetUserProps] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(enum__BOARD_TEMPLATE_TYPE.GAP, null, queryStringElementId, contextSite.username, userPropsKpi, setSetUserProps)

    const gapContextStructure = {
        userPropsKpi: {
            value: userPropsKpi
        },
        gapElementList: {
            value: elementList,
            set: setElementList,
        },
        dataserieFullData: {
            value: dataserieFullData,
            set: setDataserieFullData,
        },
        //[##]Debe ser cargado cada vez que se seleccina una revision.
        gapRevisionDataserieList: {
            value: gapRevisionDataserieList,
            set: setGapRevisionDataserieList,
        },
        
    }
    

    const [messageConfig, setMessageConfig] = useState({
        message : t('data-lang-msg-invalidboard'),
        messageType : "error",
        showMessage : true,
    });
    
    const setterSelectedRevision = (revision, _gapRevisionsList) => {
        const revisionDataseries = _gapRevisionsList.data.find(x => x.id === revision.id).l_dataserie_ids

        setSelectedRevision(revision === undefined ? null : revision)
        setHigthLigthDataserieList(revisionDataseries)
    }

    const setterStructurerevisionDataserieFullList = (value) => {
        
        setDataserieFullData(prevState => ({
            ...prevState,
            revisionDataserieFullList: value === undefined ? null : value,
            gapFishboneList: null,
            fireUpdateLastAction: true
        }));
        
        setGapRevisionDataserieList(value === undefined ? null : value)
        setGapAnalyzeDataseriesIds(value === undefined ? null : value)
    }

    //Render de componente.
    return (<>
                <AuthVerify currentToken={currentAuth} />
                {
                    userPropsKpi && (userPropsKpi.hasAccess === true || userPropsKpi.onlyObserver === true) &&
                    <>
                    {
                        gapContextStructure.dataserieFullData.value &&
                        gapContextStructure.gapElementList.value &&
                        gapContextStructure.gapRevisionDataserieList.value &&
                        gapRevisionDataserieList &&
                        dataserieFullData.revisionDataserieFullList &&
                        <GapAppContext.Provider value={ gapContextStructure }>
                            {
                                (gapAnalyze.id !== 0 && gapAnalyze.id !== null) &&
                                <>  
                                    <Row>
                                        <Col xl={7}>
                                            <Row>
                                                <Col xl={12}>
                                                    <GAPBox
                                                        inputParam_GapRevisionsList={gapRevisionsList}
                                                        inputParam_SetGapRevisionsList={setGapRevisionsList}
                                                        inputParam_GAPObject={objGAP}
                                                        inputParam_GapAnalyzeId={ gapAnalyze.id }
                                                        inputParam_SelectedElementId={parseInt(queryStringElementId)}
                                                        InputParam_ElementList={elementList}
                                                        inputParam_SetterSelectedElementId={setSelectedElementId}
                                                        inputParam_SetterStructurerevisionDataserieFullList={setterStructurerevisionDataserieFullList}
                                                        inputParam_SetsetGapRevisionDataserieList={setGapRevisionDataserieList}
                                                        inputParam_SetterGAPElements={setElementList}
                                                        inputParam_FishboneList={dataserieFullData.gapFishboneList}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className='pt-2'>
                                                <Col xl={6}>
                                                    {
                                                        gapRevisionsList.data &&
                                                        <GapRevisionsBox
                                                            inputParam_GapAnalyzeId={ gapAnalyze.id }
                                                            selectedRevision={ selectedRevision }
                                                            inputParam_SetterSelectedRevision={ setterSelectedRevision }
                                                            inputParam_GapElementId={parseInt(queryStringElementId)}
                                                            inputParam_SetterStructurerevisionDataserieFullList={setterStructurerevisionDataserieFullList}
                                                            gapRevisionsList={gapRevisionsList}
                                                            setGapRevisionsList={setGapRevisionsList}
                                                            gapRevisionsListFiltred={gapRevisionsListFiltred}
                                                            setGapRevisionsListFiltred={setGapRevisionsListFiltred}
                                                            inputParam_SetFireGetLastActions={setFireGetLastActions}
                                                        />
                                                    }
                                                    
                                                </Col>
                                                <Col xl={6}>
                                                    <GapDataseriesBox
                                                        inputParam_ElementList={elementList}
                                                        inputParam_GapRevisionDataserieList={ gapRevisionDataserieList }
                                                        inputParam_HigthLigthDataserieList={ higthLigthDataserieList }
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xl={5}>
                                            <GapActionStadistic
                                                inputParam_GapAnalyzeId={ gapAnalyze.id }
                                                inputParam_GapElementId={queryStringElementId}
                                                inputParam_DataList={dataserieFullData.revisionDataserieFullList}
                                                inputParam_GapRevisionId={selectedRevision !== null ? selectedRevision.id : null}
                                                inputParam_FireGetLastActions={fireGetLastActions}
                                                inputParam_SetFireGetLastActions={setFireGetLastActions}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="h-1001">
                                        <Col xl={12} className="py-2 h-1001">
                                            {
                                                objGAP.id !== null && gapRevisionDataserieList &&
                                                <GapDataserieFullBox
                                                    inputParam_GapId={ objGAP.id }   
                                                    inputParam_GapAnalyzeId={ gapAnalyze.id }   
                                                    inputParam_ElementId={ parseInt(queryStringElementId) }   
                                                    inputParam_GapRevision={ selectedRevision }
                                                    inputParam_DataserieFullData={ dataserieFullData }
                                                    inputParam_GapRevisionDataserieList={ gapRevisionDataserieList }
                                                    inputParam_GapElementList={ elementList }
                                                    inputParam_SetterStructurerevisionDataserieFullList={setterStructurerevisionDataserieFullList}
                                                    setDataserieFullData={setDataserieFullData}
                                                    gapAnalyzeDataseriesIds={gapAnalyzeDataseriesIds}

                                                    inputParam_SetFireGetLastActions={setFireGetLastActions}
                                                    
                                                    inputParam_SelectecDataserieId={selectecDataserieId}
                                                    inputParam_SetSelectecDataserieId={setSelectecDataserieId}
                                                />
                                            }
                                        </Col>
                                    </Row>
                                </>
                            }
                            {
                                (gapAnalyze.id !== 0 && gapAnalyze.id !== null) &&
                                <>
                                    
                                </>
                            }
                        </GapAppContext.Provider>
                    }
                    </>
                }
                {
                    userPropsKpi && (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) &&
                    <div className="pt-5 mt-4">
                        <MessageBox  
                            inputParam_Message={ (userPropsKpi.hasAccess === false ? t('data-lang-msg-accessdenied') : "") }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </div>
                } 
                {
                    userPropsKpi && (
                        !gapContextStructure.dataserieFullData.value ||
                        !gapContextStructure.gapElementList.value ||
                        !gapContextStructure.gapRevisionDataserieList.value ||
                        !gapRevisionDataserieList ||
                        !dataserieFullData.revisionDataserieFullList
                    ) &&
                    <div>
                        <Loading inputParam_ShowLoading={true}/>
                    </div>
                }
            </>
    );
}

export default Gap;